export default __webpack_public_path__ + "static/media/PRESTIGIO_IMPERO-LUCIDO_CRAQUELE_120X278_03_265.cc6c4999.jpg";